import { render } from "./ManageTableColumnsVisibilityDialog.vue?vue&type=template&id=837ad9c2&scoped=true"
import script from "./ManageTableColumnsVisibilityDialog.vue?vue&type=script&lang=js"
export * from "./ManageTableColumnsVisibilityDialog.vue?vue&type=script&lang=js"

import "./ManageTableColumnsVisibilityDialog.vue?vue&type=style&index=0&id=837ad9c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837ad9c2"]])

export default __exports__